export default class KnownError extends Error {
    /**
     * @param {string} message
     * @param {number|undefined} code
     * @param {Error|undefined} source_error
     */
    constructor(message, code, source_error) {
        super(message)
        this.name = 'KnownError'
        this.code = code
        this.source_error = source_error
    }
}
